import { useTranslation } from 'react-i18next';
import { useEffect, type ReactNode } from 'react';

import { useSession } from '@/app/store/session.store';
import { refreshSession } from '@/shared/api/httpClient';
import { Spinner } from '@/shared/ui/atoms/Spinner';

/**
 * Restores the session on load through the refresh cookie. While the outcome
 * is unknown the app shows a full-screen spinner instead of flashing the login.
 */
export function SessionProvider({ children }: { children: ReactNode }) {
  const status = useSession((s) => s.status);
  const { t } = useTranslation();

  useEffect(() => {
    if (status === 'unknown') void refreshSession();
  }, [status]);

  if (status === 'unknown') return <Spinner fullscreen label={t('common.restoring')} />;
  return <>{children}</>;
}
